import React, {useEffect, useState} from "react";
import {
    Layout,
    Breadcrumb,
    List,
    Skeleton,
    Row,
    Col,
    Card,
    Form,
    Input,
    InputNumber,
    Select,
    Button,
    message
} from 'antd';
import Api from "../api.js";
import {useParams} from "react-router-dom"
import StepsChallange from "../components/reports/steps-challenge";

const {Content} = Layout;

const ActiveInactiveReport = () => {
    const params = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
    }, [])

    const onFinishGetCustomersList = (values: any) => {
        setLoading(true)
        Api.get("/admin/reports/customer-list?email=" + values.email + "&active=" + values.status).then(res => {
            setLoading(false)
            return message.success('Report sent to ' + values.email);
        }).catch(e => {
            setLoading(false)
            return message.error(`${e.message}`);
        })
    };


    return (
        <Content style={{margin: '0 16px'}}>
            <Breadcrumb style={{margin: '16px 0'}}>
                <Breadcrumb.Item>Fitlap</Breadcrumb.Item>
                <Breadcrumb.Item>Reports</Breadcrumb.Item>
                <Breadcrumb.Item>Customers</Breadcrumb.Item>
            </Breadcrumb>


                <Col span={24}>
                    <div className="site-layout-card">
                        <h1>Active/Inactive customers</h1>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Card>
                                    <Form
                                        name="amember_customers_list"
                                        labelCol={{span: 8}}
                                        wrapperCol={{span: 16}}
                                        initialValues={{remember: true}}
                                        onFinish={onFinishGetCustomersList}
                                        autoComplete="off"
                                    >
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{required: true, message: 'Email on nõutud'}]}>
                                            <Input/>
                                        </Form.Item>

                                        <Form.Item label="Status" name="status" rules={[{required: true, message: 'Status is required'}]}>
                                            <Select
                                                defaultValue={true}
                                                style={{width: 120}}

                                                options={[{value: 'false', label: 'Inactive'}, {
                                                    value: 'true',
                                                    label: 'Active'
                                                }]}
                                            />
                                        </Form.Item>

                                        <Form.Item wrapperCol={{offset: 8, span: 16}}>
                                            <Button type="primary" htmlType="submit" loading={loading}>
                                                Generate
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Col>
        </Content>
    );
}

export default ActiveInactiveReport;